export default {"src":"/_next/static/media/dataBase.823eebbb.svg","height":23,"width":19};